import config from '@/config'
const { IMAGES_URL } = config

const downloadImages = listingData => {
  const {
    images,
    building: { full_street_name }
  } = listingData

  const imageArray = images.map((image, i) => {
    return {
      title: `${full_street_name.replace(/\s+/g, '-').toLowerCase()}-${i + 1}.jpg`,
      aws_s3_key: image.aws_s3_key
    }
  })

  let delay = 0

  imageArray.forEach(img => {
    setTimeout(async () => {
      const response = await fetch(`${IMAGES_URL}/${img?.aws_s3_key}`)
      const blob = await response.blob()
      let url = window.URL.createObjectURL(blob)
      let link = document.createElement('a')
      link.href = url
      link.download = img.title
      link.click()
    }, delay)

    delay += 500
  })
}

export default downloadImages
